import { CreateCdqLeadCommand } from '../../../../services/api/acquisition/cdqAcquisition';
import type { AcquisitionReviewSection } from '../AcquisitionConfirmDialog';
import { acquisitionEuro } from '../acquisitionAmount';
import { acquisitionLocationLabel } from '../acquisitionCustomer';
import { CDQ_OCCUPATION_LABEL, cdqYesNoLabel } from './cdqOptions';

export const CDQ_REVIEW_TITLE =
  'Conferma acquisizione lead Cessione del quinto';

/**
 * What confirming sets in motion. It stops at the point the backend's success
 * boundary stops: the credential email is asynchronous and best effort, so the
 * copy says the sending starts, never that the customer received anything.
 */
export const CDQ_REVIEW_NOTICE =
  'Confermando, la lead entra in Programma Tasso come Lead in gestione e viene creato il relativo Deal. Se il cliente non ha ancora un Account Area Clienti viene creato e ne viene avviato l’invio delle credenziali. L’operazione non è annullabile.';

/**
 * The read-only review of one compiled CdQ draft. It reads the command
 * confirmation will send, not the form behind it, so what the operator
 * approves and what leaves the browser cannot drift apart. Only the operator's
 * own answers appear: the acquisition origin, the owner, the actor, the
 * idempotency key and the server-owned `approfondisci` decision are none of
 * them the operator's, and a field whose branch does not apply is absent from
 * both the command and here.
 */
export const cdqReviewSections = (
  command: CreateCdqLeadCommand
): AcquisitionReviewSection[] => [
  {
    title: 'Richiesta',
    fields: [
      { label: 'Importo richiesto', value: acquisitionEuro(command.importo) },
    ],
  },
  {
    title: 'Situazione lavorativa e requisiti',
    fields: [
      {
        label: 'Occupazione',
        value: CDQ_OCCUPATION_LABEL[command.occupazione],
      },
      { label: 'Età', value: `${command.anni} anni` },
      { label: 'SPID', value: cdqYesNoLabel(command.spid) },
      {
        label: 'Cittadinanza italiana',
        value: cdqYesNoLabel(command.cittadinanzaItaliana),
      },
      {
        label: 'Prestiti o cessioni in corso',
        value: cdqYesNoLabel(command.altriPrestitiInCorso),
      },
      {
        label: 'Ritardi nei pagamenti',
        value: cdqYesNoLabel(command.ritardiPagamenti),
      },
      ...(command.redditoMensilePensionato !== undefined
        ? [
            {
              label: 'Pensione mensile',
              value: acquisitionEuro(command.redditoMensilePensionato),
            },
          ]
        : []),
      ...(command.stipendio !== undefined
        ? [
            {
              label: 'Reddito mensile',
              value: acquisitionEuro(command.stipendio),
            },
          ]
        : []),
      ...(command.indeterminato
        ? [
            {
              label: 'Contratto a tempo indeterminato',
              value: cdqYesNoLabel(command.indeterminato),
            },
          ]
        : []),
      ...(command.mensilita !== undefined
        ? [{ label: 'Mensilità', value: String(command.mensilita) }]
        : []),
      ...(command.tempo
        ? [{ label: 'Anni nell’azienda attuale', value: command.tempo }]
        : []),
      ...(command.nDipendenti
        ? [{ label: 'Numero di dipendenti', value: command.nDipendenti }]
        : []),
    ],
  },
  {
    title: 'Residenza',
    fields: [
      { label: 'Località', value: acquisitionLocationLabel(command.location) },
    ],
  },
  {
    title: 'Cliente',
    fields: [
      { label: 'Nome', value: command.firstName },
      { label: 'Cognome', value: command.lastName },
      { label: 'Email', value: command.email },
      { label: 'Telefono', value: `${command.phonePrefix} ${command.phone}` },
    ],
  },
];
